<template>
  <File />
</template>

<script>
import File from "./components/Filetype.vue";
export default {
  components: {
    File,
  },
};
</script>

<style></style>
